/* eslint-disable fuxi/max-params-with-fixable */
/* eslint-disable max-depth */
/* eslint-disable react-func/max-lines-per-function */
/* eslint-disable max-lines */
import Konva from 'konva';
import { Tween } from 'konva/lib/Tween';
import { nanoid } from '@reduxjs/toolkit';
import { Arrow } from 'konva/lib/shapes/Arrow';
import { Group } from 'konva/lib/Group';
import * as SentryCapacitor from '@sentry/capacitor';
import SpriteImg from '@/assets/image/point-circle.png';
import circleBg1Img from '@/assets/image/circle-bg-1.png';
import circleBg2Img from '@/assets/image/circle-bg-2.png';
import circleBg3Img from '@/assets/image/circle-bg-3.png';
import circleBg1OKImg from '@/assets/image/circle-bg-1-ok.png';
import circleBg2OKImg from '@/assets/image/circle-bg-2-ok.png';
import { storagePrefixFixedV2 } from '@/constant';
import { ModelSolutionValue } from '../model-2d/model-config';
import { getChildrenByName } from './util';

export const prefixCls = 'react-2d-viewer';

export interface ViewerProps {
  containerWidth: number;
  containerHeight: number;
  containerId: string;
  pointArr: Palpation.PointType[];
  onImageLoaded?: VoidFunc;
  imgUrl?: string;
  customCircleBgImg?: string;
  customCircleBgOkgImg?: string;
}
export enum FingerType {
  HAND = 'hand',
  FINGER = 'finger',
}

const WIDTH = 480,
  HEIGHT = 848;
export class Canvas2DViewer {
  props: ViewerProps;
  stage!: Konva.Stage;
  mergeStage!: Konva.Stage;
  imageLayer!: Konva.Layer;
  drawLayer!: Konva.Layer;
  shadowLayer!: Konva.Layer;
  pixelRatio = 1;
  transformer = new Konva.Transformer();
  textTool!: Konva.Text;
  mainImage: Konva.Image | undefined;
  nodePoints: Konva.Group[] = [];
  drawedImageList: Konva.Image[] = [];
  isInHighlightNodePoints: Konva.Group[] = [];
  isInHighlightSplines: Konva.Rect[] = [];
  pointArr: Palpation.PointType[];
  helpPoints: string[] | number[];
  currentActiveNodePointTween: {
    id: string;
    tween: Tween;
  } = null;
  currentActiveSplineTween: {
    id: string;
    tween: Tween[];
  } = null;
  currentActiveCustomLineTween: Tween = null;
  cachedTransform = {
    scaleRatio: 1,
    offsetY: 0,
    offsetX: 0,
  };
  direction = 1;
  activeSplineTime = 0;
  activeSplineFlag = 1;
  handPoint: Konva.Image;
  fingerImgObj: HTMLImageElement;
  handImgObj: HTMLImageElement;
  cachedFingerType = FingerType.HAND;
  linearColor = ['#00f0ff', '#00ff85'];
  highlightColor = '#3d7eff';
  modelBoundary = [
    [385, 495],
    [705, 1045],
  ];
  customLineAnimationTween: Array<{
    tweenId: string;
    tweenInstance: Tween;
  }> = [];

  constructor(props: ViewerProps) {
    this.pixelRatio = window.devicePixelRatio;
    Konva.pixelRatio = this.pixelRatio;
    this.props = props;
    this.initStage(props);
    this.pointArr = props.pointArr;
  }
  updatePoints = (params: {
    points: Palpation.PointTypeWithDirection[];
    isSmall?: boolean;
    isNeedOpacity?: boolean;
  }) => {
    const { points, isSmall = false, isNeedOpacity = false } = params || {};
    this.clearAllPoints();
    for (let i = 0; i < points.length; i++) {
      this.updatePoint(points[i], isSmall, isNeedOpacity);
    }
  };

  updateModelPoints = (points: Palpation.PointTypeWithDirection[]) => {
    const formatPoints = points.map(item => ({
      ...item,
      pixelPosition: {
        x: (this.modelBoundary[1][0] - this.modelBoundary[0][0]) * item.position.x + this.modelBoundary[0][0],
        y: (this.modelBoundary[1][1] - this.modelBoundary[0][1]) * item.position.y + this.modelBoundary[0][1],
      },
    }));
    this.clearAllPoints();
    for (let i = 0; i < formatPoints.length; i++) {
      this.updatePoint(formatPoints[i]);
    }
  };

  updateMassageNodulePoints = (points: Palpation.PointTypeWithDirection[], config?: { shouldMoveToTop?: boolean }) => {
    const { shouldMoveToTop = false } = config || {};

    const formatPoints = points.map(item => ({
      ...item,
      pixelPosition: {
        x: (this.modelBoundary[1][0] - this.modelBoundary[0][0]) * item.position.x + this.modelBoundary[0][0],
        y: (this.modelBoundary[1][1] - this.modelBoundary[0][1]) * item.position.y + this.modelBoundary[0][1],
      },
    }));
    for (let i = 0; i < formatPoints.length; i++) {
      this.updatePoint(formatPoints[i], false, false, shouldMoveToTop);
    }
  };

  updateDottedLinePoints = (points: string[] | number[]) => {
    const formatPoints = points?.map(item => parseInt(item));
    this.drawDottedLine(formatPoints);
    this.addCropShadow(formatPoints);
  };

  /** 清除所有渲染的按摩结节 */
  clearAllMassageNodule = () => {
    this.clearActiveNode();
    this.nodePoints = [];
    this.isInHighlightNodePoints = [];
    this.drawLayer.clearCache();
    this.drawLayer.children = this.drawLayer.children.filter(item => !item.attrs?.isMassageNodule);
  };

  // 高亮结节
  highlightNodePoint = (pointId: string) => {
    const findedNode = this.nodePoints?.find(item => item.attrs?.id === pointId);

    if (!findedNode) return;

    const isLeft = findedNode.attrs?.isLeft;

    // 删除文字图层
    findedNode.children = findedNode?.children?.filter(item => !!item?.attrs?.image);

    const willChangeImage = findedNode.children?.find(item => !!item.attrs.image) as any;
    if (!willChangeImage) return;
    const defaultCircleImg = isLeft ? circleBg1OKImg : circleBg2OKImg;

    const imageObj = new Image();
    imageObj.crossOrigin = 'Anonymous';
    imageObj.src = this.props.customCircleBgImg || defaultCircleImg;

    imageObj.onload = () => {
      willChangeImage.setImage(imageObj);
      willChangeImage.setScale({ x: 0.72, y: 0.72 });
      willChangeImage.setOffsetX(-11);
      willChangeImage.setOffsetY(-11);
    };
    this.isInHighlightNodePoints.push(findedNode);
  };

  // 高亮按摩中结节
  highlightMassageNodePoint = (pointId: string) => {
    const findedNode = this.nodePoints?.find(item => item.attrs?.id === pointId);
    if (!findedNode) return;

    const isLeft = findedNode.attrs?.isLeft;

    // 删除文字图层
    findedNode.children = findedNode?.children?.filter(item => !!item?.attrs?.image);

    const willChangeImage = findedNode.children?.find(item => !!item.attrs.image) as any;
    if (!willChangeImage) return;

    const defaultCircleImg = isLeft ? circleBg1OKImg : circleBg2OKImg;

    const imageObj = new Image();
    imageObj.crossOrigin = 'Anonymous';
    imageObj.src = this.props?.customCircleBgImg || defaultCircleImg;

    imageObj.onload = () => {
      willChangeImage.setImage(imageObj);
      willChangeImage.setScale({ x: 0.72, y: 0.72 });
      willChangeImage.setOffsetX(-11);
      willChangeImage.setOffsetY(-11);
    };
    this.isInHighlightNodePoints.push(findedNode);
  };

  // 结节动态效果
  activeNodePoint = (pointId: string) => {
    const findedNode = this.nodePoints?.find(item => item.attrs?.id === pointId);

    if (!findedNode) return;

    const ImageLayer = findedNode.children?.find(item => !!item.attrs.image);

    findedNode.moveToTop();

    const nodeTween = new Konva.Tween({
      node: ImageLayer,
      duration: 0.8,
      scaleX: 1.2,
      scaleY: 1.2,
      offsetX: 4,
      offsetY: 4,
    });

    this.currentActiveNodePointTween = {
      id: pointId,
      tween: nodeTween,
    };

    nodeTween.play();

    nodeTween.onFinish = () => {
      nodeTween.reverse();
    };
    nodeTween.onReset = () => {
      nodeTween.play();
    };
  };

  // 清除结节的动态效果
  clearActiveNode = () => {
    if (this.currentActiveNodePointTween) {
      this.currentActiveNodePointTween?.tween.reset();
      this.currentActiveNodePointTween?.tween?.destroy();
      this.currentActiveNodePointTween = null;
    }
  };

  // 清除线的动态效果
  clearActiveSpline = () => {
    if (this.currentActiveSplineTween) {
      for (const item of this.currentActiveSplineTween.tween) {
        item.reset();
        item?.destroy();
      }
      this.currentActiveSplineTween = null;
    }
  };

  // 重置所有结节的高亮效果
  resetNodeHighlight = () => {
    const imageObj = new Image();
    imageObj.crossOrigin = 'Anonymous';
    imageObj.src = SpriteImg;

    imageObj.onload = () => {
      for (const item of this.isInHighlightNodePoints) {
        const willChangeImage = item.children?.find(item => !!item.attrs.image) as any;
        willChangeImage.setImage(imageObj);
      }
      this.isInHighlightNodePoints = [];
    };
    this.clearActiveNode();
  };

  resetSplineHighlight = () => {
    if (!this.isInHighlightSplines?.length) return;

    for (const item of this.isInHighlightSplines) {
      item.dash([5, 10]);
      item.strokeWidth(3);
      item.strokeLinearGradientColorStops([0, '#3d7eff', 1, '#3d7eff']);
      item.fill('#3d7eff');
      item.stroke('#3d7eff');
    }
    this.clearActiveSpline();
    this.isInHighlightSplines = [];
  };

  initStage = (props: ViewerProps) => {
    this.stage = new Konva.Stage({
      container: props.containerId,
      width: props.containerWidth,
      height: props.containerHeight,
    });
    this.imageLayer = new Konva.Layer({ name: 'imageLayer' });
    this.drawLayer = new Konva.Layer({ name: 'drawLayer' });
    this.shadowLayer = new Konva.Layer({ name: 'shadowLayer' });
    this.stage.add(this.imageLayer);
    this.stage.add(this.shadowLayer);
    this.stage.add(this.drawLayer);

    this.drawLayer.zIndex(2);
    this.shadowLayer.zIndex(1);
    this.drawLayer.add(this.transformer);
    this.shadowLayer.add(this.transformer);

    // 动画
    // let layer = new Konva.Layer()
    // this.stage.add(layer)
    // //中心点坐标
    // let cenY = this.stage.height() / 2
    // let x = 1 / 8 * this.stage.width()
    // let y = cenY
    // let height = 1 / 12 * this.stage.height()
    // let maxWidth = 3 / 4 * this.stage.width()
    // //绘制一个进度条
    // let innerRect = new Konva.Rect({
    //     x,
    //     y,
    //     width: 100,
    //     height: height,
    //     opacity: 0.7,
    //     fill: 'red',
    //     cornerRadius: height / 2
    // })
    // layer.add(innerRect)

    // // Konva 动画效果
    // innerRect.to({
    //     width: maxWidth,
    //     duration: 1.4,
    //     // opacity: 0.3,
    //     easing: Konva.Easings.EaseInOut
    // })
    // layer.draw()
  };

  screenshot = () => {
    this.mergeStage = new Konva.Stage({
      container: this.props.containerId,
      width: this.props.containerWidth,
      height: this.props.containerHeight,
    });
    this.mergeStage.add(this.imageLayer);
    this.mergeStage.add(this.shadowLayer);
    this.mergeStage.add(this.drawLayer);
    return this.mergeStage.toCanvas().toDataURL('image/png', 1);
  };

  init = () => {
    return this.addImage(this.props.imgUrl);
  };

  addImage = (url: string) => {
    return new Promise((resolve, reject) => {
      Konva.Image.fromURL(
        url,
        image => {
          // image.cornerRadius(20);

          // 获取原始宽度和高度
          const originalWidth = image.width(),
            originalHeight = image.height(),
            stageWidth = this.stage.width(),
            stageHeight = this.stage.height();

          // 计算缩放比例
          const scale = stageHeight / originalHeight;
          const imageTransformWidth = originalWidth * scale;

          const offsetX = (stageWidth - imageTransformWidth) / 2;

          image.width(imageTransformWidth);
          image.height(stageHeight);
          this.imageLayer.add(image);

          image.offsetX(-offsetX);
          this.cachedTransform = {
            offsetX,
            offsetY: 0,
            scaleRatio: scale,
          };

          this.mainImage = image;

          this.imageLayer.draw();

          setTimeout(() => this.props?.onImageLoaded?.(), 500);
          resolve(true);
        },
        error => {
          console.error('加载konva图片失败', {
            url,
            error: error || '',
          });
          try {
            SentryCapacitor?.captureException?.({
              url,
              error: error || '',
            });
          } catch {
            console.error('异常上报错误');
          }
          reject(error);
        }
      );
    });
  };

  changeImageLayer = async (url: string) => {
    this.imageLayer.clearCache();
    this.imageLayer.children = [];

    await this.addImage(url);
  };

  // 添加手势图标
  // addHandPoint = () => {
  //   this.fingerImgObj = new Image();
  //   this.handImgObj = new Image();

  //   return new Promise((resolve, reject) => {
  //     this.handImgObj.onload = () => {
  //       this.handPoint = new Konva.Image({ name: 'finger', width: 50, height: 50, image: this.handImgObj });
  //       this.drawLayer.add(this.handPoint);
  //       resolve(resolve);
  //     };
  //     this.handImgObj.src = HandImg;
  //     this.fingerImgObj.src = FingerImg;
  //   });
  // };
  // eslint-disable-next-line fuxi/max-params-with-fixable
  createSprite = (width, height, group: Konva.Group, bgUrl: string, opacity: number) => {
    const imageObj = new Image();
    imageObj.onload = () => {
      const sprite = new Konva.Image({
        width,
        height,
        image: imageObj,
        opacity,
      });
      sprite.position({
        x: -width / 2,
        y: -height / 2,
      });
      group.add(sprite);
      sprite.zIndex(0);
    };
    imageObj.crossOrigin = 'Anonymous';
    imageObj.src = bgUrl;
  };
  createCircle = (point: Palpation.PointType) => {
    const radius = 20;
    const group = new Konva.Group({ name: point.index.toString() });
    const outerCircle = new Konva.Circle({
      radius: radius,
      fillRadialGradientStartRadius: 0,
      fillRadialGradientEndRadius: radius,
      fillRadialGradientColorStops: [0, 'rgba(54, 135, 255, 0.2)', 1, 'rgba(70, 205, 255, 0.2)'],
    });
    const middleCircle = new Konva.Circle({
      radius: radius * 0.8,
      fillRadialGradientStartRadius: 0,
      fillRadialGradientEndRadius: radius * 0.8,
      fillRadialGradientColorStops: [0, 'rgba(54, 135, 255, 0.4)', 1, 'rgba(70, 205, 255, 0.4)'],
    });

    const innerCircle = new Konva.Circle({
      radius: radius * 0.6,
      fillRadialGradientStartRadius: 0,
      fillRadialGradientEndRadius: radius * 0.6,
      fillRadialGradientColorStops: [0, 'rgba(54, 135, 255, 1)', 1, 'rgba(70, 205, 255, 1)'],
    });

    const text = new Konva.Text({
      fontSize: 16,
      fontStyle: 'normal',
      align: 'center',
      verticalAlign: 'middle',
      stroke: 'white',
      fill: 'white',
    });
    const { width, height } = text.measureSize(point.index.toString());

    text.text(point.index.toString());

    text.position({ x: (-1 * width) / 2, y: (-1 * height) / 2 });
    group.add(outerCircle);
    group.add(middleCircle);
    group.add(innerCircle);
    group.add(text);
    const transformedGroup = this.transformPoint(point);
    group.position({
      x: transformedGroup.x,
      y: transformedGroup.y,
    });
    return {
      group,
      outerCircle,
      innerCircle,
      middleCircle,
    };
  };
  drawDynamicCircle = (point: Palpation.PointType) => {
    const { group, outerCircle, innerCircle, middleCircle } = this.createCircle(point);

    this.drawLayer.add(group);

    this.direction = 1;

    const anim = new Konva.Animation(() => {
      const diff = 0.005;
      let scaleX = outerCircle.scaleX();
      // console.log(frame)
      if (this.direction === -1) {
        //在缩小
        scaleX -= diff;
        //scaleX >= 2
        if (scaleX <= 1) {
          this.direction = 1;
        }
      } else if (this.direction === 1) {
        //在放大
        scaleX += diff;
        if (scaleX >= 1.2) {
          this.direction = -1; //该缩小了
        }
      }

      outerCircle.scale({ x: scaleX, y: scaleX });
      middleCircle.scale({ x: scaleX, y: scaleX });
      innerCircle.scale({ x: scaleX, y: scaleX });
    }, this.drawLayer);

    anim.start();
  };

  clearAllPoints = () => {
    if (!this.nodePoints?.length) return;

    for (let i = 0; i < this.nodePoints.length; i++) {
      this.nodePoints[i].remove();
      this.nodePoints[i]?.destroy();
    }
    this.nodePoints = [];
  };

  updatePoint = (
    point: Palpation.PointTypeWithDirection,
    isSmall = false,
    isNeedOpacity = false,
    shouldMoveToTop = false
  ) => {
    const radius = isSmall ? 40 : 50;
    const pointName = point?.index || point?.name;

    const group = new Konva.Group({
      name: pointName.toString(),
      id: point.noduleId || point?.id,
      isLeft: point?.isLeft,
      attrs: { isMassageNodule: true },
    });

    let defaultCircleImg = point?.depthWarning ? circleBg3Img : point?.isLeft ? circleBg1Img : circleBg2Img;

    const defaultOpacity = isNeedOpacity && !point?.depthWarning ? 0.4 : 1;

    this.createSprite(radius, radius, group, this.props.customCircleBgImg || defaultCircleImg, defaultOpacity);

    const text = new Konva.Text({
      fontSize: isSmall ? 14 : 16,
      fontStyle: 'normal',
      align: 'center',
      verticalAlign: 'middle',
      stroke: 'white',
      fill: 'white',
      lineHeight: 1.2,
      opacity: defaultOpacity,
    });
    const { width, height } = text.measureSize(pointName.toString());

    text.text(pointName.toString());
    text.position({ x: (-1 * width) / 2, y: (-1 * height) / 2 });

    group.add(text);
    const transformedPoint = this.transformPoint(point);
    group.position({
      x: transformedPoint.x,
      y: transformedPoint.y,
    });
    this.drawLayer.add(group);
    this.nodePoints.push(group);

    shouldMoveToTop && setTimeout(() => group?.moveToTop(), 150);

    // this.addTextTool();
    // this.transformer.nodes([this.points[0]]);
    // this.nodePoints[0].on('dragmove', () => {
    //   this.updateText();
    // });
  };

  addTextTool = () => {
    this.textTool = new Konva.Text({ fontSize: 16, x: 5, y: 5 });
    this.drawLayer.add(this.textTool);
    this.drawLayer.draw();
  };
  updateText = () => {
    const node = this.nodePoints[0];
    const lines = [
      'x: ' + (node.x() - this.cachedTransform.offsetX) / this.cachedTransform.scaleRatio,
      'y: ' + (node.y() - this.cachedTransform.offsetY) / this.cachedTransform.scaleRatio,
    ];
    this.textTool.text(lines.join('\n'));
  };

  /**
   * 绘制图片
   */
  drawImage = (
    coord: number[],
    imageConfig: ModelSolutionValue['imageConfig'],
    config?: {
      opacity?: number;
      animation?: 'opacity' | 'rotate-left' | 'rotate-right';
      isMainBg?: boolean;
      elementId?: string;
    }
  ): Promise<Konva.Image> => {
    const { opacity = 1, isMainBg = false, animation, elementId } = config || {};

    return new Promise(resolve => {
      const { url, size } = imageConfig || {};
      const transformedCoords = this.transformPoints(coord);
      const transformedSize = size.map(item => this.cachedTransform.scaleRatio * item);

      const imageObj = new Image();

      imageObj.onload = () => {
        const image = new Konva.Image({
          ...(!!size ? { width: transformedSize[0], height: transformedSize[1] } : {}),
          // 设置动画旋转时中心点
          ...(animation === 'rotate-left' || animation === 'rotate-right'
            ? {
                offsetX: transformedSize[0] / 2,
                offsetY: transformedSize[1] / 2,
              }
            : {}),
          image: imageObj,
        });
        image.position({ x: transformedCoords[0], y: transformedCoords[1] });
        image.attrs.isMainBg = !!isMainBg;
        elementId && (image.attrs.elementId = elementId);

        image.opacity(opacity);
        this.drawLayer.add(image);
        this.drawedImageList.push(image);

        if (animation === 'opacity') {
          const tween = new Konva.Tween({
            node: image,
            opacity: 0.2, // 将透明度设置为0
            duration: 2, // 动画持续时间，单位为秒
            onFinish: () => {
              tween.reverse();
            },
            onReset: () => {
              tween.play();
            },
          });
          tween.play();
        } else if (animation === 'rotate-left' || animation === 'rotate-right') {
          const tween = new Konva.Tween({
            node: image,
            duration: 0.6, // 动画持续时间，单位为秒
            rotation: animation === 'rotate-left' ? -60 : 60,
            scaleX: 0,
            scaleY: 0,
            onFinish: () => {
              setTimeout(() => tween.reset(), 400);
            },
            onReset: () => {
              tween.play();
            },
          });
          tween.play();
        }
        resolve(image);
      };
      imageObj.crossOrigin = 'Anonymous';
      imageObj.src = url;
    });
  };

  private animationArrowUrl = storagePrefixFixedV2 + '/model-texture/animation-arrow.png';

  drawAnimationArrow = async (config: { coord: number[]; offsetY: number }) => {
    const { coord, offsetY } = config || {};

    const image = await this?.drawImage(coord, { url: this.animationArrowUrl, size: [65, 140] });

    const tween = new Konva.Tween({
      node: image,
      duration: 2,
      opacity: 0,
      y: image.y() + offsetY, // 动画持续时间，单位为秒
      onFinish: () => {
        setTimeout(() => tween.reset(), 1500);
      },
      onReset: () => {
        tween.play();
      },
    });
    tween.play();
  };

  /** 清除绘制的图片 */
  clearDrawedImage = () => {
    if (!this.drawedImageList?.length) return;

    for (const item of this.drawedImageList) {
      item?.destroy?.();
    }
    this.drawedImageList = [];
  };

  /** 通过elementId清除绘制的图片 */
  clearDrawedImageByElementId = (elementId: string) => {
    if (!elementId) return;

    this.drawedImageList =
      this.drawedImageList?.filter(item => {
        if (item.attrs?.elementId === elementId) {
          item?.destroy?.();
          return false;
        } else {
          return true;
        }
      }) || [];
  };

  // 绘制曲线
  drawSpline = (name: string, points: number[]) => {
    const line = new Konva.Line({
      name,
      stroke: '#3D7EFF',
      strokeWidth: 3,
      lineCap: 'round',
      lineJoin: 'round',
      tension: 1,
      dash: [5, 10],
    });
    const transformedPoints = this.transformPoints(points);
    line.points(transformedPoints);
    this.drawLayer.add(line);
  };

  //绘制虚线
  drawDottedLine = (
    points: number[],
    config?: Partial<{
      dash: number[];
      stroke: string;
      opacity: number;
      lineId: number;
    }>
  ) => {
    const { dash, stroke, opacity, lineId } = config || {};

    const transformedPoints = this.transformPoints(points);
    const line = new Konva.Line({
      attrs: {
        isDottedLine: true,
        lineId,
      },
      points: transformedPoints ?? [],
      stroke: stroke || '#FFFFFFA6',
      strokeWidth: 2,
      lineCap: 'square',
      lineJoin: 'round',
      dash: dash || [4, 6],
      tension: 0.5,
      opacity: opacity ?? 1,
    });

    this.drawLayer.add(line);
  };

  /** 绘制带有箭头的虚线 */
  drawDottedCircleLine = (
    points: number[],
    config?: Partial<{
      dash: number[];
      stroke: string;
      opacity: number;
      lineId: string;
    }>
  ) => {
    if (!points?.length) return;

    const { dash, stroke, opacity, lineId } = config || {};

    const transformedPoints = this.transformPoints(points);

    const line = new Konva.Arrow({
      points: transformedPoints ?? [],
      fill: stroke || '#FFFFFF',
      stroke: stroke || '#FFFFFF',
      strokeWidth: 2,
      lineCap: 'round',
      lineJoin: 'round',
      dash: dash || [5, 5],
      tension: 0,
      opacity: opacity ?? 1,
      pointerLength: 6, // 箭头长度
      pointerWidth: 6, // 箭头宽度
    });

    const circle = new Konva.Circle({
      x: transformedPoints[0],
      y: transformedPoints[1],
      radius: 4,
      fill: stroke || '#FFFFFF',
      opacity: opacity ?? 1,
    });

    const arrowsGroup = new Konva.Group({
      attrs: {
        isArrowDottedLine: true,
        lineId,
      },
    });

    arrowsGroup.add(line);
    arrowsGroup.add(circle);

    this.drawLayer.add(arrowsGroup);
  };

  // 改变带箭头虚线的颜色
  changeDottedLineCircleColor = (lineId: string, color: string) => {
    const group = this.drawLayer?.children.find(
      item => item?.attrs?.lineId === lineId && item.attrs?.isArrowDottedLine
    ) as Group;
    if (!group) return;

    group?.children?.forEach((item: any) => {
      if (item?.constructor?.name === 'Arrow') {
        item?.setStroke(color);
        item?.setFill(color);
      } else if (item?.constructor?.name === 'Circle') {
        item?.setFill(color);
      }
    });
  };

  animateDottedLine = (lineId: string) => {
    const groups = this.drawLayer?.children.filter(
      item => item?.attrs?.lineId === lineId && item.attrs?.isArrowDottedLine
    ) as Group[];

    if (!groups?.length) return;

    if (this.customLineAnimationTween?.length) {
      this.customLineAnimationTween.forEach(item => item?.tweenInstance?.reset()?.destroy());
      this.customLineAnimationTween = [];
    }

    groups?.forEach(group => {
      group?.children?.forEach(shape => {
        let repeatCount = 3;
        const tweenId = nanoid(6);

        const tweenInstance = new Konva.Tween({
          node: shape,
          duration: 0.6,
          opacity: 0.1,
          strokeWidth: 10,
          radius: 10,
        });

        this.customLineAnimationTween.push({ tweenId, tweenInstance });

        tweenInstance.play();
        tweenInstance.onFinish = () => {
          tweenInstance.reverse();
        };
        tweenInstance.onReset = () => {
          tweenInstance.play();

          if (repeatCount > 1) {
            repeatCount--;
          } else {
            tweenInstance.destroy();
            this.customLineAnimationTween = this.customLineAnimationTween?.filter(item => item.tweenId !== tweenId);
          }
        };
      });
    });
  };

  /** 在模型上绘制带有箭头的虚线 */
  drawCircleLineWithPixelCoord = (
    points: number[] | number[][],
    config?: Partial<{
      dash: number[];
      stroke: string;
      opacity: number;
      lineId: string;
    }>
  ) => {
    if (!points?.length) return;

    const { dash, stroke, opacity, lineId } = config || {};

    // 判断是否是二维数组
    if (typeof points?.[0] === 'number') {
      const transformedPoints = this.transformPoints(points as number[]);

      const line = new Konva.Arrow({
        points: transformedPoints ?? [],
        fill: stroke || '#FFFFFF',
        stroke: stroke || '#FFFFFF',
        strokeWidth: 3,
        lineCap: 'round',
        lineJoin: 'round',
        dash: dash || [5, 7],
        tension: 0,
        opacity: opacity ?? 1,
        pointerLength: 8, // 箭头长度
        pointerWidth: 8, // 箭头宽度
      });

      const showdowCircle = new Konva.Circle({
        attrs: {
          isShadowCircle: true,
        },
        x: transformedPoints[0],
        y: transformedPoints[1],
        radius: 5,
        fill: `${stroke}50`,
        opacity: opacity ?? 1,
      });

      const circle = new Konva.Circle({
        x: transformedPoints[0],
        y: transformedPoints[1],
        radius: 6,
        fill: stroke || '#FFFFFF',
        opacity: opacity ?? 1,
      });

      const arrowsGroup = new Konva.Group({
        attrs: {
          isArrowDottedLine: true,
          lineId,
        },
      });

      arrowsGroup.add(line);
      arrowsGroup.add(showdowCircle);
      arrowsGroup.add(circle);

      this.drawLayer.add(arrowsGroup);
    } else {
      const Lines = points?.reduce<Arrow[]>((accur, cur) => {
        const transformedPoints = this.transformPoints(cur as number[]);

        const line = new Konva.Arrow({
          points: transformedPoints ?? [],
          fill: stroke || '#FFFFFF',
          stroke: stroke || '#FFFFFF',
          strokeWidth: 3,
          lineCap: 'round',
          lineJoin: 'round',
          dash: dash || [5, 10],
          tension: 0,
          opacity: opacity ?? 1,
          pointerLength: 8, // 箭头长度
          pointerWidth: 8, // 箭头宽度
        });

        accur.push(line);

        return accur;
      }, []);
      const arrowsGroup = new Konva.Group({
        attrs: {
          isArrowDottedLine: true,
          lineId,
        },
      });

      Lines?.forEach(shape => arrowsGroup.add(shape));

      this.drawLayer.add(arrowsGroup);
    }
  };

  deleteDottedLineCircleByIds = (lineId: string[]) => {
    if (!lineId) return;

    this.drawLayer.clearCache();
    this.drawLayer.children = this.drawLayer?.children?.filter(item => {
      // 非箭头虚线，则不删除
      if (!item.attrs?.isArrowDottedLine) {
        return true;
      } else {
        return !lineId?.includes(item?.attrs?.lineId);
      }
    });
  };

  deleteAllDottedLineCircle = () => {
    this.drawLayer.clearCache();
    this.drawLayer.children = this.drawLayer?.children?.filter(item => {
      // 非箭头虚线，则不删除
      if (!item.attrs?.isArrowDottedLine) {
        return true;
      } else {
        return false;
      }
    });
  };

  /** 在模型上绘制带有箭头的虚线 */
  drawDottedCircleLineInModel = (
    points: number[],
    config?: Partial<{
      dash: number[];
      stroke: string;
      opacity: number;
      lineId: string;
    }>
  ) => {
    const formatXcoords = (coordX: number) =>
      (this.modelBoundary[1][0] - this.modelBoundary[0][0]) * coordX + this.modelBoundary[0][0];

    const formatYcoords = (coordY: number) =>
      (this.modelBoundary[1][1] - this.modelBoundary[0][1]) * coordY + this.modelBoundary[0][1];

    if (!points?.length) return;

    const { dash, stroke, opacity, lineId } = config || {};

    const transformedPoints = this.transformPoints(
      points?.map((coord, index) => (index % 2 === 0 ? formatXcoords(coord) : formatYcoords(coord)))
    );

    const line = new Konva.Arrow({
      points: transformedPoints ?? [],
      fill: stroke || '#FFFFFF',
      stroke: stroke || '#FFFFFF',
      strokeWidth: 3,
      lineCap: 'round',
      lineJoin: 'round',
      dash: dash || [5, 7],
      tension: 0,
      opacity: opacity ?? 1,
      pointerLength: 8, // 箭头长度
      pointerWidth: 8, // 箭头宽度
    });

    const showdowCircle = new Konva.Circle({
      attrs: {
        isShadowCircle: true,
      },
      x: transformedPoints[0],
      y: transformedPoints[1],
      radius: 5,
      fill: `${stroke}50`,
      opacity: opacity ?? 1,
    });

    const circle = new Konva.Circle({
      x: transformedPoints[0],
      y: transformedPoints[1],
      radius: 8,
      fill: stroke || '#FFFFFF',
      opacity: opacity ?? 1,
    });

    const arrowsGroup = new Konva.Group({
      attrs: {
        isArrowDottedLine: true,
        lineId,
      },
    });

    arrowsGroup.add(line);
    arrowsGroup.add(showdowCircle);
    arrowsGroup.add(circle);

    this.drawLayer.add(arrowsGroup);
  };

  /** 高亮自定义画线的线段 */
  highlightDottedCircleLineInModel = (
    lineId: string | number,
    config?: {
      changeToSolidLine?: boolean;
    }
  ) => {
    const { changeToSolidLine = false } = config || {};

    const group = this.drawLayer?.children.find(
      item => item?.attrs?.lineId === lineId && item.attrs?.isArrowDottedLine
    ) as Group;

    if (!group) {
      console.error(`未找到group: ${lineId}`);
      return;
    }

    group?.children?.forEach((item: any) => {
      if (item?.constructor?.name === 'Arrow') {
        item.setStrokeWidth(3);
        item?.setOpacity(1);

        item.fill('#abc4f5');
        item.stroke('#abc4f5');
        item.strokeLinearGradientColorStops(null);

        if (changeToSolidLine) {
          item?.setDash(0);
        }
      } else if (item.attrs.isShadowCircle) {
        item.fill('#abc4f5');
        item.stroke('#abc4f5');
        item?.setOpacity(0.5);
      } else {
        item.fill('#abc4f5');
        item.stroke('#abc4f5');
        item?.setOpacity(0.8);
      }
    });
  };

  /**
   * 线段动态效果
   */
  activeDottedCircleLineInModel = (lineId: string | number) => {
    if (this.currentActiveCustomLineTween) {
      this.highlightDottedCircleLineInModel(this.currentActiveCustomLineTween?.node?.attrs?.lineId);
      this.currentActiveCustomLineTween?.reset()?.destroy();
      this.currentActiveCustomLineTween = null;
    }

    if (!lineId) return;

    const group = this.drawLayer?.children.find(
      item => item?.attrs?.lineId === lineId && item.attrs?.isArrowDottedLine
    ) as Group;

    if (!group) {
      console.error(`未找到group: ${lineId}`);
      return;
    }

    group?.moveToTop();

    let coords = [];
    const arrowShapes = [];

    group?.children?.forEach((item: any) => {
      if (item?.constructor?.name === 'Arrow') {
        arrowShapes.push(item);
        coords = item?.attrs?.points;
      } else if (item.attrs.isShadowCircle) {
        item.fill('#00eefe55');
        item.stroke('#00eefe55');
      } else {
        item.fill('#00eefe');
        item.stroke('#00eefe');
        item?.setOpacity(0.8);
      }
    });

    if (!arrowShapes?.length) return;

    arrowShapes?.forEach(arrowShape => {
      arrowShape.setStrokeWidth(5);
      arrowShape.setDashEnabled(false);
      arrowShape.strokeLinearGradientStartPoint({
        x: coords[0],
        y: coords[1],
      });

      arrowShape.strokeLinearGradientEndPoint({
        x: coords[coords.length - 2],
        y: coords[coords.length - 1],
      });

      arrowShape?.setOpacity(1);
      arrowShape.fill('#00f0ff');
      arrowShape.strokeLinearGradientColorStops([0, this.linearColor[0], 1, this.linearColor[1]]);
    });

    const tweenInstance = new Konva.Tween({
      node: group,
      duration: 0.4,
      opacity: 0,
    });

    tweenInstance.onFinish = () => {
      tweenInstance.reverse();
    };
    tweenInstance.onReset = () => {
      tweenInstance.play();
    };
    tweenInstance.play();

    this.currentActiveCustomLineTween = tweenInstance;
  };

  // 添加阴影再裁减掉传入坐标点形成的多边形
  addCropShadow = (points: number[]) => {
    const transformedPoints = this.transformPoints(points);
    const rectangle = new Konva.Rect({
      x: 0,
      y: 0,
      width: this.props.containerWidth,
      height: this.props.containerHeight,
      fill: '#0000004D',
    });

    const polygon = new Konva.Shape({
      sceneFunc: function (context, shape) {
        context.beginPath();
        context.moveTo(transformedPoints[0], transformedPoints[1]);
        for (let i = 2; i < transformedPoints.length; i += 2) {
          context.lineTo(transformedPoints[i], transformedPoints[i + 1]);
        }
        context.closePath();
        context.fillStrokeShape(shape);
      },
      fill: 'white',
      globalCompositeOperation: 'destination-out',
      opacity: 1,
    });

    this.shadowLayer.add(rectangle);
    this.shadowLayer.add(polygon);
  };

  //绘制箭头曲线
  drawArrowSpline = (
    name: string,
    points: number[] | number[][],
    groupCoord?: [number, number],
    config?: { opacity?: number }
  ) => {
    const { opacity = 0.8 } = config || {};

    // 是否是曲线组
    if (!groupCoord?.length) {
      const transformedPoints = this.transformPoints(points as number[]);
      const arrow = new Konva.Arrow({
        name,
        stroke: '#4179ee',
        fill: '#4179ee',
        strokeWidth: 3,
        lineCap: 'round',
        lineJoin: 'round',
        tension: 0.5,
        opacity: opacity,
        dash: [5, 10],
        points: transformedPoints,
      });

      this.drawLayer.add(arrow);
    } else {
      const allSpline = [];
      points.forEach(pointsItem => {
        allSpline.push(
          new Konva.Arrow({
            stroke: '#4179ee',
            fill: '#4179ee',
            strokeWidth: 3,
            lineCap: 'round',
            opacity: opacity,
            lineJoin: 'round',
            tension: 0.5,
            dash: [5, 10],
            points: pointsItem,
          })
        );
      });

      const transformedGroupCoord = this.transformPoints(groupCoord);
      // 创建箭头组
      const arrowsGroup = new Konva.Group({
        name,
        x: transformedGroupCoord[0],
        y: transformedGroupCoord[1],
      });

      allSpline.forEach(item => arrowsGroup.add(item));

      this.drawLayer.add(arrowsGroup);
    }
  };

  drawCircle = (name: string, points: [number, number], withDoubleCircle = false, config?: { opacity?: number }) => {
    const { opacity = 1 } = config || {};

    const transformedPoints = this.transformPoints(points);

    const circle1 = new Konva.Circle({
      name,
      stroke: '#4179ee',
      fill: '#4179ee',
      radius: 5,
      lineCap: 'round',
      opacity,
      lineJoin: 'miter',
      x: transformedPoints[0],
      y: transformedPoints[1],
    });
    this.drawLayer.add(circle1);

    if (withDoubleCircle) {
      const circle2 = new Konva.Circle({
        name,
        stroke: '#4179ee',
        fill: '#4179ee',
        radius: 9,
        opacity: 0.2,
        lineCap: 'round',
        lineJoin: 'miter',
        x: transformedPoints[0],
        y: transformedPoints[1],
      });

      this.drawLayer.add(circle2);
    }
  };

  /**
   * 处理线段高亮
   */
  private handleHighlightSpline = (spline, isBold = false) => {
    spline.zIndex(1);
    // const coords = spline?.attrs?.points;

    spline.dash([]);
    spline.opacity(1);
    spline.setStrokeWidth(isBold ? 6 : 3);

    // spline.strokeLinearGradientStartPoint({
    //   x: coords[0],
    //   y: coords[1],
    // });

    // spline.strokeLinearGradientEndPoint({
    //   x: coords[coords.length - 2],
    //   y: coords[coords.length - 1],
    // });

    spline.fill(this.highlightColor);
    spline.strokeLinearGradientColorStops(null);

    this.isInHighlightSplines.push(spline);
  };

  /**
   * 高亮线段
   */
  highlightSpline = (name: string, isBold = false, circleName?: string) => {
    const spline = getChildrenByName(this.drawLayer, name)?.[0];

    if (circleName) {
      const circles = getChildrenByName(this.drawLayer, circleName);

      if (circles?.length) {
        for (const item of circles) {
          if (item?.attrs?.opacity !== 0.2) {
            item?.setOpacity(1);
          }
        }
      }
    }

    if (!spline) {
      console.error(`未找到spline: ${name}`);
      return;
    }

    if (spline.constructor.name === 'Group') {
      this.highlightGroupLine(name, isBold);
      return;
    }

    if (spline.constructor.name !== 'Arrow') return;

    this.handleHighlightSpline(spline);
  };

  /**
   * 高亮组中的线段
   */
  private highlightGroupLine = (groupName: string, isBold = false) => {
    const group = getChildrenByName(this.drawLayer, groupName)?.[0];

    if (group.constructor.name !== 'Group') return;

    // fix 组内所有线无法同时高亮的问题
    const allSpline = [];
    group.getChildren(item => allSpline.push(item));
    allSpline.forEach(item => this.handleHighlightSpline(item, isBold));
  };

  /**
   * 高亮圆形状
   */
  highlightCircle = (name: string) => {
    const circles = getChildrenByName(this.drawLayer, name);

    if (!circles?.length) return;

    for (const circle of circles) {
      if (!circle) continue;

      // circle.fill(this.linearColor[0]);
      // circle.stroke(this.linearColor[0]);
      circle.fill('#00eefe');
      circle.stroke('#00eefe');
      circle.zIndex(12);
      this.isInHighlightSplines.push(circle);
    }
  };

  /**
   * 高亮圆形状
   */
  resetCircleColor = (name: string) => {
    const circles = getChildrenByName(this.drawLayer, name);

    if (!circles?.length) return;

    for (const circle of circles) {
      if (!circle) continue;

      // circle.fill(this.linearColor[0]);
      // circle.stroke(this.linearColor[0]);
      circle.fill(this.highlightColor);
      circle.stroke(this.highlightColor);
      circle.zIndex(12);
    }
  };

  getPointAtTime = (arrow, time) => {
    const startPoint = { x: arrow.points()[0], y: arrow.points()[1] };
    const endPoint = { x: arrow.points()[arrow.points().length - 2], y: arrow.points()[arrow.points().length - 1] };

    const x = startPoint.x + (endPoint.x - startPoint.x) * time;
    const y = startPoint.y + (endPoint.y - startPoint.y) * time;
    return { x: x, y: y };
  };

  getCanvasScaleRatio = () => {
    return this.cachedTransform.scaleRatio;
  };

  handleActiveSplineMethonds = (spline, splineName) => {
    const coords = spline?.attrs?.points;

    spline.setStrokeWidth(6);
    spline.strokeLinearGradientStartPoint({
      x: coords[0],
      y: coords[1],
    });

    spline.strokeLinearGradientEndPoint({
      x: coords[coords.length - 2],
      y: coords[coords.length - 1],
    });

    spline.fill('#00f2dd');
    spline.strokeLinearGradientColorStops([0, this.linearColor[0], 1, this.linearColor[1]]);

    const splineTween = new Konva.Tween({
      node: spline,
      duration: 0.4,
      opacity: 0,
      // strokeWidth: 12,
      // strokeLinearGradientColorStops: [0, this.linearColor[0], 1, this.linearColor[1]],
    });

    splineTween.onFinish = () => {
      splineTween.reverse();
    };
    splineTween.onReset = () => {
      splineTween.play();
    };

    if (!this.currentActiveSplineTween) {
      this.currentActiveSplineTween = {
        id: splineName,
        tween: [splineTween],
      };
    } else {
      this.currentActiveSplineTween.tween.push(splineTween);
    }

    return () => splineTween.play();
  };

  /**
   * 线段动态效果
   */
  activeSpline = (name: string, circleName: string) => {
    const spline = getChildrenByName(this.drawLayer, name)?.[0];
    const circles = !!circleName && getChildrenByName(this.drawLayer, circleName);

    if (!spline) {
      console.error(`未找到spline: ${name}`);
      return;
    }
    this.highlightSpline(name, true);

    if (spline?.constructor?.name === 'Group') {
      const splineTweens = [];
      for (const splineItem of spline?.children) {
        splineTweens.push(this.handleActiveSplineMethonds(splineItem, name));
      }

      splineTweens.forEach(item => item?.());
    } else {
      this.handleActiveSplineMethonds(spline, name)?.();
    }

    if (circles?.length) {
      for (const circle of circles) {
        this.highlightCircle(circleName);
        const circleTween = new Konva.Tween({
          node: circle,
          duration: 0.4,
          opacity: 0,
          // strokeLinearGradientColorStops: [0, this.linearColor[0], 1, this.linearColor[1]],
        });
        circleTween.play();
        circleTween.onFinish = () => {
          circleTween.reverse();
        };
        circleTween.onReset = () => {
          circleTween.play();
        };
        this.currentActiveSplineTween.tween.push(circleTween);
      }
    }
    // TODO 动画待完善
    return;

    const allPointsData = spline.points();
    if (allPointsData.length < 5) {
      const anim = new Konva.Animation(frame => {
        const diff = 0.015;

        if (this.activeSplineTime < 1) {
          this.activeSplineTime += diff;
        } else {
          this.activeSplineTime = 0;

          const allFillCircle = this.drawLayer.children?.filter(item => item.attrs.id === 'fill-line');
          allFillCircle.forEach(item => item?.destroy());
        }
        const pos = this.getPointAtTime(spline, this.activeSplineTime);

        const dot = new Konva.Circle({
          id: 'fill-line',
          x: pos.x,
          y: pos.y,
          radius: 3,
          fill: 'green',
        });

        this.drawLayer.add(dot);
      });

      anim.start();
    } else {
      const anim2 = new Konva.Animation(function (frame) {
        const time = frame.time;
        const schedule = (time % 1000) / 100;
        console.log(schedule);
        spline.points(allPointsData.slice(0, Math.floor(schedule) * 2));
      }, this.drawLayer);

      anim2.start();
    }
  };

  clearDrawLayer = () => {
    this.clearDrawedImage();
    this.drawLayer.clearCache();
    this.drawLayer.children.splice(1);
  };

  clearAllDrawLayer = () => {
    this.clearDrawedImage();
    this.drawLayer.clearCache();
    this.drawLayer.children = [];
  };

  // 清除除了mainBg的视图
  clearDrawLayerExceptMainBg = () => {
    this.drawLayer.clearCache();
    const remainChildren = this.drawLayer?.children.filter((item, index) =>
      index === 0 ? true : !!item?.attrs?.isMainBg
    );
    this.drawLayer.children = remainChildren;
  };

  //更新线段
  updateSpline = (name: string, points: number[]) => {
    const splines = getChildrenByName(this.drawLayer, name);
    if (splines.length > 0) {
      const transformedPoints = this.transformPoints(points);
      splines[0].points(transformedPoints);
    }
  };

  transformPoint = (point: Palpation.PointType) => {
    const pos = point.pixelPosition;
    const transformedX = pos.x * this.cachedTransform.scaleRatio + this.cachedTransform.offsetX;
    const transformedY = pos.y * this.cachedTransform.scaleRatio + this.cachedTransform.offsetY;
    return {
      ...point,
      x: transformedX,
      y: transformedY,
    };
  };
  transformPoints = (points: number[]) => {
    if (!(points?.length && this.mainImage)) return [];

    const transformedPoints = [];

    const { x, y } = this.mainImage.crop();

    for (let i = 0; i < points.length; i += 2) {
      transformedPoints.push(points[i] * this.cachedTransform.scaleRatio + this.cachedTransform.offsetX - x);
      transformedPoints.push(points[i + 1] * this.cachedTransform.scaleRatio + this.cachedTransform.offsetY - y);
    }
    return transformedPoints;
  };

  //更新手势图标
  // updateHandPoint = (posX, posY, type) => {
  //   const { x, y } = this.transformPoint({ pixelPosition: { x: posX, y: posY }, index: 1, noduleId: 'handPoint' });
  //   this.handPoint.position({ x, y });
  //   if (type === this.cachedFingerType) {
  //     return;
  //   }
  //   if (type === FingerType.HAND) {
  //     this.handPoint.image(this.handImgObj);
  //   } else {
  //     this.handPoint.image(this.fingerImgObj);
  //   }
  // };

  destroy = () => {
    this.mainImage?.destroy();
    this.mainImage?.clearCache();
    this.mainImage?.remove();

    this.drawLayer?.clearCache();
    this.drawLayer?.remove();
    this.drawLayer?.destroy();
    this.shadowLayer?.clearCache();
    this.shadowLayer?.remove();
    this.shadowLayer?.destroy();
    this.imageLayer?.clearCache();
    this.imageLayer?.remove();
    this.imageLayer?.destroy();
    this.stage?.clearCache();
    this.stage?.remove();
    this.stage?.destroy();
    this.mergeStage?.clearCache();
    this.mergeStage?.remove();
    this.mergeStage?.destroy();
  };
}
